import { render, staticRenderFns } from "./detay.vue?vue&type=template&id=35d8d9eb"
import script from "./detay.vue?vue&type=script&lang=js"
export * from "./detay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports